import { combineReducers } from 'redux';
import charity from './charity';
import server from './server';
import carousel from './carousel';

const appReducer = combineReducers({
  server,
  charity,
  carousel,
});

let rootReducer = (state, action) => {
  return appReducer(state, action); // action.type and data from the viewaction  is in the action parameter
};

export default rootReducer;
